// utils/encryptTransform.js
import { createTransform } from 'redux-persist';
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.SECRET_KEY || 'hydrokey';

// ✅ CORRECT - menggunakan createTransform
export const encryptTransform = createTransform(
  // inbound function (state → storage)
  (inboundState, _key) => {
    try {
      const serialized = JSON.stringify(inboundState);
      const encrypted = CryptoJS.AES.encrypt(serialized, SECRET_KEY).toString();
      return encrypted;
    } catch (error) {
      console.error('Encryption error:', error);
      return inboundState;
    }
  },

  // outbound function (storage → state)
  (outboundState, _key) => {
    try {
      if (typeof outboundState === 'string') {
        const bytes = CryptoJS.AES.decrypt(outboundState, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted ? JSON.parse(decrypted) : null;
      }
      return outboundState;
    } catch (error) {
      console.error('Decryption error:', error);
      return null;
    }
  }
);

// ✅ Export sebagai DEFAULT jika perlu
export default encryptTransform;
